import { API } from '../Auth';
import { getDataSourceNumericId } from './datasourcesApi';

const EP = 'discoverRuns';
const BASE = '/api/v1/schedules';

/**
 * Persist or remove the schedule for a data source after save.
 *
 * @param {object} row - UI row with schedule fields and data source id
 * @returns {Promise<void>}
 */
export async function maybePersistSchedulePlaceholder(row) {
  const dataSourceId = getDataSourceNumericId(row);
  if (dataSourceId == null) return;

  if (row.scheduleEnabled) {
    const body = {
      dataSourceId,
      jobType: 'DISCOVER',
      dayOfWeek: row.scheduleDayOfWeek || 'SAT',
      weekOccurrence: row.scheduleWeekOccurrence || 1,
      hour: row.scheduleHour != null ? row.scheduleHour : 0,
      minute: row.scheduleMinute != null ? row.scheduleMinute : 0,
      enabled: true,
    };

    // Check if a schedule already exists for this data source
    const existing = await listSchedulesForDataSource(dataSourceId, 'DISCOVER');
    if (existing.length > 0) {
      await API.put(EP, `${BASE}/${existing[0].id}`, { body });
    } else {
      await API.post(EP, BASE, { body });
    }
  } else {
    // Schedule disabled — delete any existing schedule
    const existing = await listSchedulesForDataSource(dataSourceId, 'DISCOVER');
    for (const schedule of existing) {
      await API.del(EP, `${BASE}/${schedule.id}`);
    }
  }
}

/**
 * Fetch schedules for a data source and job type.
 */
export async function listSchedulesForDataSource(dataSourceId, jobType) {
  try {
    const params = { queryStringParameters: { dataSourceId, jobType } };
    const result = await API.get(EP, BASE, params);
    return Array.isArray(result) ? result : [];
  } catch (e) {
    console.log('listSchedulesForDataSource error', e);
    return [];
  }
}

/**
 * Load schedule data for a data source and merge onto a UI row.
 *
 * @param {object} uiRow - the UI data source row
 * @returns {object} uiRow with schedule fields merged
 */
export async function mergeScheduleIntoUiRow(uiRow) {
  const dataSourceId = getDataSourceNumericId(uiRow);
  if (dataSourceId == null) return uiRow;

  try {
    const schedules = await listSchedulesForDataSource(dataSourceId, 'DISCOVER');
    if (schedules.length > 0) {
      const s = schedules[0];
      return {
        ...uiRow,
        scheduleId: s.id,
        scheduleEnabled: s.enabled,
        scheduleDayOfWeek: s.dayOfWeek,
        scheduleWeekOccurrence: s.weekOccurrence,
        scheduleHour: s.hour,
        scheduleMinute: s.minute,
        scheduleRules: uiRow.scheduleRules, // preserve UI rules selection
      };
    }
  } catch (e) {
    console.log('mergeScheduleIntoUiRow error', e);
  }

  return uiRow;
}
